module.exports = __webpack_public_path__ + "static/media/Feedback Icon.0f057913.svg";